import propName from './prop-name';
import tuple from './tuple';
import { string } from './type-checkers';

const formatters = string.type('formatters');

export default tuple([propName, formatters]).group('formatters');
